module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn-form', {
    attrs: {
      "title": _vm.title,
      "mode": _vm.isLoaded
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function() {
        return [_c('v-btn', {
          on: {
            "click": function($event) {
              return _vm.open(_vm.fileItem.uid)
            }
          }
        }, [_vm._v("Открыть")]), _vm._v(" "), _c(_vm.createCopyButton('Ссылку', 'content_copy', 'Копировать ссылку', _vm.copyLink), {
          tag: "v-component"
        }), _vm._v(" "), _c('v-spacer')]
      },
      proxy: true
    }])
  }, [(_vm.fileItem) ? _c('v-flex', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticStyle: {
      "display": "block",
      "overflow-wrap": "break-word"
    }
  }, [_c('span', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.fileItem.docName))]), _vm._v(" "), _c(_vm.renderDepoFileSignature(_vm.fileItem), {
    tag: "v-component"
  })], 1), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "display": "block",
      "overflow-wrap": "break-word"
    }
  }, [_c('v-flex', [_vm._v("\n        Cсылка: "), _c('b', [_c('a', {
    attrs: {
      "href": _vm.getUrl(_vm.fileItem.uid)
    }
  }, [_vm._v(_vm._s(_vm.getUrl(_vm.fileItem.uid)))])])]), _vm._v(" "), _c('v-flex', [_vm._v("\n        Депонировано: "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(_vm.fileItem.uploaded, _vm.formats.formatDateTime)))]), _vm._v(" (по: " + _vm._s(_vm.formats.blank(_vm.fileItem.deleted, _vm.formats.formatDate)) + ")\n        ")]), _vm._v(" "), _c('v-flex', [_vm._v("\n        Депонент: "), _c('b', [_vm._v(_vm._s(_vm.fileItem.ownerShortName))]), _vm._v(" ИНН: " + _vm._s(_vm.formats.formatInn(_vm.fileItem.ownerInn)) + "\n        ")])], 1)], 1), _vm._v(" "), (_vm.history.length > 0) ? _c('v-card', [_c('v-panel-title', {
    attrs: {
      "value": _vm.isLoaded,
      "caption": 'История',
      "expandable": true
    },
    on: {
      "click": function($event) {
        _vm.isLoaded = !_vm.isLoaded
      }
    }
  }, [_c('span', [_vm._v("ВАЖНО! Депонент загрузил новые версии файла с момента депонирования, показана актуальная версия! Смотрите изменения в "), _c('a', {
    on: {
      "click": function($event) {
        _vm.isLoaded = true
      }
    }
  }, [_vm._v("истории")]), _vm._v(", рекомендуем "), _c('a', {
    on: {
      "click": function($event) {
        return _vm.copyLink()
      }
    }
  }, [_vm._v("обновить ссылку")]), _vm._v(".")])]), _vm._v(" "), (_vm.isLoaded) ? _c('v-card-text', {
    staticStyle: {
      "display": "block",
      "overflow-wrap": "break-word"
    }
  }, [_vm._l((_vm.history), function(item) {
    return [_c('v-flex', [_vm._v("\n        Название: "), _c('b', [_vm._v(_vm._s(item.docName))]), _vm._v(" "), _c(_vm.renderDepoFileSignature(item), {
      tag: "v-component"
    })], 1), _vm._v(" "), _c('v-flex', [_c('span', [_vm._v("\n        Депонировано: "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(item.uploaded, _vm.formats.formatDateTime)))]), _vm._v(" (по: " + _vm._s(_vm.formats.blank(item.deleted, _vm.formats.formatDate)) + ")\n        "), _c('v-btn', {
      attrs: {
        "small": "",
        "flat": ""
      },
      on: {
        "click": function($event) {
          return _vm.open(item.uid)
        }
      }
    }, [_vm._v("Открыть")])], 1)])]
  })], 2) : _vm._e()], 1) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2682e478","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/depo/DocProp.vue
// module id = 1184
// module chunks = 1